import React, { Component } from 'react';
import { Button, Col, Switch, Form, Row, Icon } from 'antd';
import moment from 'moment-timezone';

class MultiFactorFormComponent extends Component {
    handleSubmit(e) {
        e.preventDefault();
        const { form, onSubmit } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const timezone = this.props.data.timezone || 'UTC';

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 }
            }
        };
        return (
            <Form onSubmit={this.handleSubmit.bind(this)}>
                <Row gutter={24}>
                    <Col md={24}>
                        <Form.Item label="Enable" {...formItemLayout}>
                            {getFieldDecorator('use_mfa', {
                                valuePropName: 'checked'
                            })(<Switch />)}
                        </Form.Item>
                    </Col>
                    <Col md={24}>
                        {this.props.enrollments.map((enrollment, i) => {
                            return (
                                <div
                                    key={i}
                                    style={{
                                        padding: 10,
                                        marginBottom: 10,
                                        background: 'rgba(0,0,0,0.2)'
                                    }}
                                >
                                    <Icon type="mobile" /> <b>{enrollment.type}</b> Registered:{' '}
                                    {moment(enrollment.enrolled_at)
                                        .tz(timezone)
                                        .format('DD/MM/YYYY hh:mm:ss a')}
                                </div>
                            );
                        })}
                    </Col>
                    <Col style={{ textAlign: 'right' }} md={24}>
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}
export const MultiFactorForm = Form.create({
    mapPropsToFields: props => {
        const data = {};

        Object.keys(props.data || {}).forEach(k => {
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        console.log(data);
        return data;
    }
})(MultiFactorFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Settings/MultiFactorForm.js